export default __webpack_public_path__ + "static/media/2.58cca049.png";